import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { connectMediaStore } from '../../../_hocs/withOwnReduxStore';
import PopupInnerLayout from '../../../_partials/PopupInnerLayout';
import SelectedItemsPanel from '../../../_partials/SelectedItemsPanel';
import { getPostStreamIdFromMediaSource } from '../../../helpers';
import { fetchMorePosts } from '../../../actions';
import { getCurrentMediaSource } from '../../../selectors';
import { getDeviationsByIds } from '../../../../redux/deviations/selectors';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import LoadingIndicator from '../../../../LoadingIndicator';
import { selectors } from '../../../../Stream';
import DeviationSelector from '../';
const enhance = compose(connectMediaStore((state)=>{
    const streamId = getPostStreamIdFromMediaSource(getCurrentMediaSource(state));
    return {
        deviations: getDeviationsByIds(state, selectors.getItems(state, streamId)),
        isFetching: selectors.isFetching(state, streamId),
        hasMore: selectors.hasMore(state, streamId),
        isInitialized: selectors.isInitialized(state, streamId)
    };
}, {
    fetchMorePosts
}), withMobileContext, withTranslation());
export class PostDeviationSelector extends React.Component {
    render() {
        return /*#__PURE__*/ React.createElement(PopupInnerLayout, {
            headerExtrasBottomZone: /*#__PURE__*/ React.createElement(SelectedItemsPanel, null),
            scrollableContent: this.renderContent(),
            onScrolledToBottom: this.fetchMoreIfNeeded,
            onNotScrollable: this.fetchMoreIfNeeded
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "fetchMoreIfNeeded", ()=>{
            const { hasMore, isFetching } = this.props;
            if (!hasMore || isFetching) {
                return;
            }
            this.props.fetchMorePosts();
        });
        _define_property(this, "renderContent", ()=>{
            const { isInitialized, isFetching, deviations, hasMore } = this.props;
            return /*#__PURE__*/ React.createElement(React.Fragment, null, isInitialized && deviations.length > 0 && /*#__PURE__*/ React.createElement(DeviationSelector, {
                deviations: deviations
            }), (!isInitialized || isFetching) && /*#__PURE__*/ React.createElement(LoadingIndicator, {
                view: "daSymbol",
                coverMode: !hasMore
            }));
        });
    }
}
export default enhance(PostDeviationSelector);
